import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, initializeAppTheme } from "./store";
import { ToastProvider } from "./hooks/useToast";
import { AppProviders } from "./components/Provider";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

// Initialize theme before rendering
initializeAppTheme();

// Create toast root element if it doesn't exist
if (!document.getElementById("toast-root")) {
  const toastRoot = document.createElement("div");
  toastRoot.id = "toast-root";
  document.body.appendChild(toastRoot);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppProviders>
        <BrowserRouter>
          <ToastProvider>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </ToastProvider>
        </BrowserRouter>
      </AppProviders>
    </Provider>
  </React.StrictMode>,
);
